// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__yWTKd"};